module.exports = __webpack_public_path__ + "img/img7.c3cd0285.png";